import type { GroupDto } from "@ied/shared-types";
import {
	createColumnHelper,
	getCoreRowModel,
	type TableOptions,
} from "@tanstack/react-table";
import { useGetGroups } from "@/hooks/queries/use-get-groups";
import { TanstackTable } from "../ui/table";

export function GroupsTable() {
	const { data } = useGetGroups();

	if (!data) {
		return <p>No groups</p>;
	}

	const cHelper = createColumnHelper<GroupDto>();
	const columns = [
		cHelper.accessor("id", {
			header: () => "Id",
		}),
		cHelper.accessor("group_name", {
			header: () => "Group Name",
		}),
		cHelper.accessor("abbreviation", {
			header: () => "Abbreviation",
		}),
		cHelper.accessor("status", {
			header: () => "Status",
		}),
		cHelper.accessor("created", {
			header: () => "Created",
			cell: (row) => (
				<div>
					<p>{new Date(row.getValue()).toLocaleDateString()}</p>
					<p>{new Date(row.getValue()).toLocaleTimeString()}</p>
				</div>
			),
		}),
		cHelper.accessor("updated", {
			header: () => "Updated",
			cell: (row) => (
				<div>
					<p>{new Date(row.getValue()).toLocaleDateString()}</p>
					<p>{new Date(row.getValue()).toLocaleTimeString()}</p>
				</div>
			),
		}),
	];

	const tableOptions: TableOptions<GroupDto> = {
		columns,
		data,
		getCoreRowModel: getCoreRowModel(),
	};
	return (
		<>
			<TanstackTable options={tableOptions} />
		</>
	);
}
